var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0c-282.506 0-512 229.494-512 512 0 282.509 229.494 512 512 512 282.509 0 512-229.491 512-512 0-282.506-229.491-512-512-512zM512 44.522c258.445 0 467.475 209.033 467.475 467.478s-209.030 467.475-467.475 467.475c-258.445 0-467.478-209.030-467.478-467.475s209.033-467.478 467.478-467.478zM489.739 356.174c-0.168-12.278 9.636-22.374 21.914-22.565 6.017-0.094 11.815 2.252 16.075 6.502s6.616 10.045 6.534 16.063v133.565h133.566c8.026-0.113 15.494 4.104 19.539 11.039 4.051 6.934 4.051 15.51 0 22.445-4.045 6.934-11.514 11.152-19.539 11.039h-133.566v133.566c0.113 8.026-4.104 15.494-11.039 19.539-6.934 4.051-15.51 4.051-22.445 0-6.934-4.045-11.152-11.514-11.039-19.539v-133.566h-133.565c-8.028 0.113-15.496-4.104-19.542-11.039s-4.047-15.51 0-22.445c4.047-6.934 11.514-11.152 19.542-11.039h133.565v-133.565z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleAdd);
export default __webpack_public_path__ + "static/media/circle-add.94d639ef487d48ba4e3c023083f2aa2f.svg";
export { ForwardRef as ReactComponent };